import en from './staticVocabularies/en.json';
import pl from './staticVocabularies/pl.json';
import uk from './staticVocabularies/uk.json';
import { ESupportedLocales } from './localization.enums';

export const getBrowserLocale = () => {
  const browserLocalePlain = navigator.language;
  if (browserLocalePlain.includes(ESupportedLocales.EN))
    return ESupportedLocales.EN;
  if (browserLocalePlain.includes(ESupportedLocales.PL))
    return ESupportedLocales.PL;
  if (browserLocalePlain.includes(ESupportedLocales.UK))
    return ESupportedLocales.UK;

  return ESupportedLocales.EN;
};

export const getUserLocaleVocabularyByLocale = (
  userLocale?: ESupportedLocales
) => {
  if (!userLocale) return en;

  const browserLocale = getBrowserLocale();

  switch (browserLocale) {
    case ESupportedLocales.EN:
      return en;
    case ESupportedLocales.PL:
      return pl;
    case ESupportedLocales.UK:
      return uk;
    default:
      return en;
  }
};
